import * as React from 'react';
import styled from 'styled-components';
import {transparentize} from 'polished';
import Radio from 'components/Radio';
import {transition} from 'helpers/css';

export interface RadioCardProps {
  label: string;
  onClick: () => void;
  discountLabel?: string;
  description?: string;
  checked?: boolean;
}

export const Container = styled.label<Pick<RadioCardProps, 'checked'>>`
  position: relative;
  display: grid;
  grid-template-columns: 20px 1fr;
  gap: 10px;
  align-items: start;
  padding: 10px;
  border-radius: 5px;
  box-sizing: border-box;
  border: 1px solid rgba(223, 223, 223, 0.05);
  cursor: pointer;
  
  ${transition()}

  background: ${({theme, checked}) => checked
    ? transparentize(.98, theme.colors.white)
    : theme.variables.accentBackgroundColor};
  
  &:hover {
    background: ${({theme}) => transparentize(
      .98,
      theme.colors.white)};
  }
`;

const Title = styled.div`
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 10px;
  
  font-size: 13px;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0.01em;
`;

const Content = styled.div`
  z-index: 1;
`;

const Description = styled.div`
  margin-top: 4px;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.01em;
  color: ${({theme}) => transparentize(.6, theme.variables.color)};
`;

const Discount = styled.div`
  margin-top: 8px;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.01em;
  text-align: left;
  color: ${({theme}) => theme.colors.primaryLight}
`;

/**
 * render tariffs plan component
 * @param {any} props
 * @constructor
 */
export default function RadioCard(props: RadioCardProps): React.ReactElement {
  // eslint-disable-next-line require-jsdoc
  function renderDiscount() {
    if (props.discountLabel) {
      return (
        <Discount>{props.discountLabel}</Discount>
      );
    }
  }

  // eslint-disable-next-line require-jsdoc
  function renderDescription() {
    if (props.discountLabel) {
      return (
        <Description>{props.description}</Description>
      );
    }
  }

  return (
    <Container checked={props.checked} onClick={props.onClick}>
      <Radio checked={props.checked}/>
      <Content>
        <Title>{props.label}</Title>
        {renderDiscount()}
        {renderDescription()}
      </Content>
    </Container>
  );
}
